
import React, { useEffect } from 'react';
import { NavBar } from 'antd-mobile'

import { 
    BodyView
} from "../factory/ViewUtil";
import { FullURL } from '../factory/FactoryUtil';

const FeedbackPreviewController = ({gohome, goback, data}) => {

    const imgsrc = data.img || ''
    useEffect(() => {
        if(imgsrc.length === 0) {
            gohome()
        }
    })
    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>Preview</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <div style={{marginTop : '20px'}}>
                    <img alt='' src={FullURL(imgsrc)} style={{
                        width : '100%',
                        height : '100%',
                        objectFit : 'contain',
                    }}/>
                </div>
            </BodyView>
        </>
    );
}
export default React.memo(FeedbackPreviewController)